import {
  AGGRID_AUTOCOLUMN_ID,
  HamburgerMenu,
  filterByCellValueMenuItem,
  useDynamicCallback,
  useJsonModal,
  useMixpanel,
  type AgGridMenuItems,
  type Column,
  type ColumnDef,
  type CreditBlotterExposure,
  type Exposure,
  type FilterableProperty,
  type UseFilterBuilderOutput,
} from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-community';
import { useMemo, type ReactNode } from 'react';
import { colIDToFilterBuilderKey } from './useCreditFilter';

export function useCreditMenu({
  openClause,
  filterableProperties,
}: {
  openClause: UseFilterBuilderOutput['addAndOpenClause'];
  filterableProperties: FilterableProperty<string>[];
}): {
  column: Column;
  getCustomContextMenuItems: (params: GetContextMenuItemsParams) => AgGridMenuItems;
  dialogs: ReactNode;
} {
  const mixpanel = useMixpanel();
  const { handleClickJson, jsonModal } = useJsonModal();
  const getCustomContextMenuItems = useDynamicCallback((params: GetContextMenuItemsParams) => {
    const isTreeGroupingColumn = params.column?.getColId() === AGGRID_AUTOCOLUMN_ID;

    return filterByCellValueMenuItem({
      params,
      filterableProperties,
      openClause,
      colIDToFilterBuilderKey,
      mixpanel,
      colID: isTreeGroupingColumn ? ('MarketAccount' satisfies keyof CreditBlotterExposure) : undefined,
    });
  });

  const dialogs = useMemo(() => <>{jsonModal}</>, [jsonModal]);

  const column = useMemo(
    () =>
      ({
        type: 'hamburgerMenu',
        id: 'rowMenu',
        params: {
          renderItems: params => <HamburgerMenu {...params} onShowJson={handleClickJson} />,
        },
      }) satisfies ColumnDef<Exposure>,
    [handleClickJson]
  );

  return {
    column,
    getCustomContextMenuItems,
    dialogs,
  };
}
